import {
  HttpReadWriteDeleteStore,
  ProjectionEntityStore,
} from '@soniq/public-resource'
import {
  contactRelationshipSchema,
  ContactRelationshipSchema,
  validateContactRelationship,
} from '@soniq/schema-connection'

export class ContactRelationshipHttpStore extends HttpReadWriteDeleteStore<ContactRelationshipSchema> {
  static new() {
    return new ContactRelationshipHttpStore(
      'contact_relationship',
      validateContactRelationship
    )
  }
}

export class ContactRelationshipProjectionStore extends ProjectionEntityStore<ContactRelationshipSchema> {
  static new() {
    return new ContactRelationshipProjectionStore(
      'contact_relationship',
      contactRelationshipSchema
    )
  }
}
